import { Account, ConnectAdditionalRequest, TonProofItemReplySuccess } from "@tonconnect/ui-react";

const apiUrl = import.meta.env.VITE_BASE_URL;

export interface IAuthData {
    rawAddress: string;
    friendlyAddress: string;
    network: string;
    publicKey: string | null;
    stateInit: string | null;
    proof: TonProofItemReplySuccess["proof"];
}

export const AuthController = {
    async checkProof(proof: TonProofItemReplySuccess["proof"], account: Account) {
        try {
            const reqBody = {
                rawAddress: account.address,
                network: account.chain,
                friendlyAddress: account.friendlyAddress,

                ref: localStorage.getItem("referral_code") ?? null,

                publicKey: account.publicKey,
                stateinit: account.walletStateInit,
                proof: {
                    ...proof,
                    state_init: account.walletStateInit,
                },
            };

            const response = await (
                await fetch(`${apiUrl}/auth/signin/tonconnect`, {
                    method: "POST",
                    body: JSON.stringify(reqBody),

                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                })
            ).json();
            if (response?.data?.jwt) return response.data.jwt;
        } catch (e) {
            console.log("checkProof error:", e);
        }
    },

    async reset() {
        localStorage.removeItem("jwt");
        this.generatePayload();
    },

    // --- 429 global cooldown vars ---
    _generatePayloadCooldownUntil: 0,
    async generatePayload(): Promise<ConnectAdditionalRequest | null> {
        const now = Date.now();
        if (now < (AuthController._generatePayloadCooldownUntil || 0)) {
            const secondsLeft = Math.ceil((AuthController._generatePayloadCooldownUntil - now) / 1000);
            throw new Error(`429: Too Many Requests. Please wait ${secondsLeft}s before retrying.`);
        }
        try {
            const response = await fetch(`${apiUrl}/auth/signin/tonconnect/payload`);
            if (response.status === 429) {
                AuthController._generatePayloadCooldownUntil = Date.now() + 10000;
                throw new Error("429: Too Many Requests. Please wait 10s before retrying.");
            }
            const { data } = await response.json();
            return { tonProof: data.payload as string };
        } catch (e) {
            return null;
        }
    },
};
